// src/Pages/Home.js
import React from 'react';

const Home = () => {
  return <div>Welcome to Home Page</div>;
};

export default Home;
